/** @format */

import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import "./footer.css";
import { Row, Col } from "react-bootstrap";

const Footer = () => {
	const mapContainerStyle = {
		width: "100%",
		height: "300px",
		borderRadius: "8px",
	};

	return (
		<footer className="footer-container" id="contact">
			<div className="footer-content container">
				{/* Map Section */}
				<div className="footer-map">
					<h3>Our Location</h3>
					<iframe
						className="col-12"
						width="100%"
						height="260"
						frameBorder="0"
						scrolling="no"
						marginHeight="0"
						marginWidth="0"
						id="gmap_canvas"
						src="https://www.google.com/maps/embed/v1/place?q=sri+rajarajeshwara+clinic%27s&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
				</div>

				{/* Flex Container for Contact and Social */}
				<div className="footer-flex">
					{/* Address Section */}
					<div className="footer-address">
						<h3>Contact Us</h3>
						<p>
							<strong>SRI RAJARAJESHWARA CLINICS</strong>
							<br />
							6-2-119/1, Kakaji Colony, Kakaji Nagar Colony, Hanamkonda,
							Telangana 506001, India
							<br />
							Phone: +91 8686101203
							<br />
							Email:
						</p>
					</div>

					{/* Social Media Section */}
					<div className="footer-social">
						<h3>Follow Us</h3>
						<div className="social-icons">
							<a
								href="https://facebook.com"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Facebook">
								<FaFacebook size={30} />
							</a>
							<a
								href="https://instagram.com"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Instagram">
								<FaInstagram size={30} />
							</a>
							<a
								href="https://linkedin.com"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="LinkedIn">
								<FaLinkedin size={30} />
							</a>
						</div>
					</div>
				</div>
			</div>
			<hr className="my-4" />
			<Row>
				<Col className="text-center">
					<p className="mb-0">
						&copy; {new Date().getFullYear()}{" "}
						<a href="https://hextgen.com/">HextGen</a>. All rights reserved.
					</p>
				</Col>
			</Row>
		</footer>
	);
};

export default Footer;
